export const FORM_ID = "post-form";
